import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import gtmTracker from '@utils/gtmTracker';

import useEnglishTranslation from '@hooks/use-english-translation';

import { PROMOTION_STATUS, PromotionType } from '@types';

import { Button } from '@components/button';
import { PromotionDate } from '@components/promotion-date';

import * as Styled from './current-promotion-card.styled';

type OwnProps = {
	promo: PromotionType;
	isParticipating: boolean;
};

const CurrentPromotionCard: React.FC<OwnProps> = ({ promo, isParticipating }) => {
	const { t } = useTranslation('promotions');
	const tEn = useEnglishTranslation(['promotions', 'main']);
	const navigate = useNavigate();

	const handleStatus = () => {
		switch (promo.status) {
			case PROMOTION_STATUS.ACTIVE:
				return t('chip_started');
			case PROMOTION_STATUS.PENDING:
				return t('chip_new');
			default:
				return 'Err';
		}
	};

	const handleButtonClick = (id: string) => {
		gtmTracker.trackEvent('click', {
			event_category: 'Promotions',
			event_action: 'click',
			event_label: isParticipating ? tEn('tickets_buy') : tEn('main:readMoreBtn')
		});
		navigate('/promotion', { state: { promotionId: id } });
	};

	return (
		<Styled.Wrapper $bg={promo.image}>
			<Styled.Content>
				<Styled.DateRow>
					<Styled.Chip $isActive={isParticipating}>{isParticipating ? 'Учавствуете' : handleStatus()}</Styled.Chip>
					<PromotionDate isActive={isParticipating} isSmall start_date={promo.start_date} end_date={promo.end_date} />
				</Styled.DateRow>
				<Styled.TextContainer>
					<Styled.Title>{promo.name}</Styled.Title>
					<Styled.Description>{promo.description}</Styled.Description>
				</Styled.TextContainer>
				<Styled.ButtonWrapper>
					<Button onClick={() => handleButtonClick(promo.id)} color={isParticipating ? 'primary' : 'dark'}>
						{isParticipating ? t('tickets_buy') : t('main:readMoreBtn')}123
					</Button>
				</Styled.ButtonWrapper>
			</Styled.Content>
		</Styled.Wrapper>
	);
};

export default CurrentPromotionCard;
